import React from 'react'

// Components
// import UIDashboardQuickSight from '../../UI/Dashboard/QuickSight'

const DashboardDash = () => {
  return (
    <iframe
      src="http://pocsha-datam-2qmu2hnskb4q-1988967551.sa-east-1.elb.amazonaws.com/alerts-dashboard/"
      width="700"
      height="600"
    />
  )
}

export default DashboardDash
